/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import Text from 'src/components/ts-components/Text'
import SelectMultiInput from 'src/components/ts-components/SelectMultiInput'
import { useDivisionSetupContext } from '../../context'
import colors from '@sportninja/common/constants/appColors'
import { isCanlan } from '@sportninja/common/utils/customer-name'

const Payments = () => {
  const { state, setState, availableTaxes } = useDivisionSetupContext()

  return (
    <div
      css={css`
        display: flex;
        padding: 16px;
        gap: 16px;
        flex-direction: column;
        align-items: flex-end;
      `}
    >
      <div
        css={css`
          display: flex;
          align-items: flex-start;
          gap: 8px;
          align-self: stretch;
          width: 100%;
          flex-direction: column;
        `}
      >
        <Text variant='captionLarge' weight='semiBold'>
          Division Taxes
        </Text>
        <Text
          variant='paragraphXSmall'
          weight='regular'
          color={colors.NEUTRAL_50}
        >
          Specify the taxes that will be applied to this division.
          <br />
          If you want to apply taxes{' '}
          {isCanlan ? 'season-wide' : 'competition-wide'}, you can do so in the
          the registration settings.
        </Text>
      </div>

      <SelectMultiInput
        label='Taxes'
        options={
          availableTaxes?.map((tax) => ({
            label: tax.name,
            value: tax.id,
          })) || []
        }
        value={state.taxes}
        onChange={(value) => {
          setState({
            ...state,
            taxes: value,
          })
        }}
        fieldErrors={state.fieldErrors}
        customError={state.customError}
        name='taxes'
      />
    </div>
  )
}

export default Payments
